export const IS_NOT_ENV_PROD = process.env?.REACT_APP_ENV !== 'production';
